/**
 * Polyfill for __filename support in browser environments
 *
 * In Node.js, __filename provides the file path, but this isn't available in browser/Vite.
 * This utility allows code to import a compatible function to use in logging.
 */

/**
 * Creates a filename string for the current module
 * @param relativePath The relative path to the current file (e.g., 'src/Components/Button.ts')
 * @returns A string to use in place of __filename
 */
export const createFilename = (relativePath: string): string => {
  return relativePath
}
